export const configKeys = {
  /**
   * Config key for cloud translation uri
   * @type {string}
   */
  CLOUD_TRANSLATION_URI_CONFIG_KEY: 'apis.cloud.translation.uri',
};
